/**
 * CSV export for filtered dashboard observations.
 * Generates a blob and triggers a browser download.
 */

import type { DashboardObservation } from './types';
import { SUBSCALE_META } from './types';

const COLUMNS = [
  'Record ID',
  'Exported At',
  'Observation Date',
  'Site Name',
  'Provider Name',
  'Observer Name',
  'Observer Email',
  'Children Present',
  'Age Groups Present',
  'Start Time',
  'End Time',
  'Total Average',
  'Scored Items',
  'NA Items',
  'Pending Items',
  ...SUBSCALE_META.map((s) => `${s.id}: ${s.name}`),
  'Notes',
];

function escCsv(v: string | number | null): string {
  if (v === null || v === undefined) return '';
  const s = String(v);
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function exportCsv(observations: DashboardObservation[]): void {
  const rows = observations.map((o) => [
    o.recordId,
    o.exportedAt,
    o.observationDate,
    o.siteName,
    o.providerName,
    o.observerName,
    o.observerEmail,
    o.childrenPresent,
    o.ageGroupsPresent,
    o.startTime,
    o.endTime,
    o.totalAverage,
    o.scoredItems,
    o.naItems,
    o.pendingItems,
    o.subscaleAverages.S1,
    o.subscaleAverages.S2,
    o.subscaleAverages.S3,
    o.subscaleAverages.S4,
    o.subscaleAverages.S5,
    o.subscaleAverages.S6,
    o.notes,
  ]);

  const csv = [
    COLUMNS.map(escCsv).join(','),
    ...rows.map((r) => r.map(escCsv).join(',')),
  ].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `fccers-dashboard-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
